export enum FilterNameEnum {
	Guides = 'Guides',
	Ages = 'Ages',
	Genres = 'Genres',
	Modes = 'Modes'
}
